import './index.scss'

$('.footer .footer-info .info-title .backTop,.aside-social .backTop').on('click',function(){
  $("html, body").animate({
    scrollTop: 0
  }, {duration: 500,easing: "swing"});
  return false;
})